module.exports = __webpack_public_path__ + "static/img/notLogin.d0158d1f.png";